import BaseApi from './base';

class DeliveryDocument extends BaseApi {
    endpoint = 'delivery-documents';

    finish(id) {
        return this.getAxios().put(`/${this.endpoint}/${id}/finish`);
    }

    finishAll(data) {
        return this.getAxios().post(`/${this.endpoint}/finish`, data);
    }

    active(id, params) {
        return this.getAxios().put(`/${this.endpoint}/${id}/active`, params);
    }
}

export default new DeliveryDocument();




// WEBPACK FOOTER //
// ./src/psuite-js/apis/delivery/document.js